<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="投标人澄清问题">
                <el-form-item label="问题标题" prop="yqcqwttitle" class="table-full-row">
                    {{form.yqcqwttitle||'-'}}
                </el-form-item>
                 <el-form-item label="要求澄清的问题" prop="yqcqwt" class="table-full-row">
                    <el-input v-html="form.yqcqwt"  type="textarea" :rows="4"></el-input>
                </el-form-item>
               <el-form-item label="附件" class="table-full-row">
                    <!-- <my-upload readonly  :file-guid="form.fileguid"></my-upload> -->
                    <yygl-upload v-if="isnm == '1' || isnm == '2'" readonly  :file-guid="form.fileguid"></yygl-upload>
                    <my-upload v-else readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item> 
            </my-form-item-group>

            <my-form-item-group title="回复问题" v-if="form.exthfbj===null||form.exthfbj==='0'">
                <el-form-item label="回复内容" prop="txthfcontent" class="table-full-row" :rules="newRule('回复内容', 'required')">
                    <ueditor v-model="form.txthfcontent"></ueditor>
                </el-form-item>

                <el-form-item label="附件" class="table-full-row">
                    <!-- <my-upload :file-guid="form.byfileguid"></my-upload> -->
                    <yygl-upload v-if="isnm == '1' || isnm == '2'"  :file-guid="form.byfileguid"></yygl-upload>
                    <my-upload v-else  :file-guid="form.byfileguid"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <template v-else>
                <my-form-item-group title="回复问题">
                    <el-form-item label="追加回复" prop="txthfcontent" class="table-full-row" :rules="newRule('追加回复内容', 'required')">
                        <ueditor v-model="form.txthfcontent"></ueditor>
                    </el-form-item>

                    <el-form-item label="附件" class="table-full-row">
                        <!-- <my-upload :file-guid="form.byfileguid"></my-upload> -->
                        <yygl-upload v-if="isnm == '1' || isnm == '2'"  :file-guid="form.byfileguid"></yygl-upload>
                        <my-upload v-else  :file-guid="form.byfileguid"></my-upload>
                    </el-form-item>
                </my-form-item-group>
                <my-form-item-group title="历史回复">
                    <el-form-item label="历史回复" prop="exthfcontent" class="table-full-row">
                        <el-input v-html="form.exthfcontent" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="历史附件" class="table-full-row">
                        <!-- <my-upload readonly :file-guid="form.exthffileguid"></my-upload> -->
                        <yygl-upload v-if="isnm == '1' || isnm == '2'" readonly  :file-guid="form.exthffileguid"></yygl-upload>
                        <my-upload v-else readonly  :file-guid="form.exthffileguid"></my-upload>
                    </el-form-item>
                </my-form-item-group>
            </template>

            <template slot="btn" class="btn" slot-scope="scope">
                <div v-if="form.exthfbj===null||form.exthfbj==='0'">
                    <el-button icon="el-icon-circle-check" type="primary" @click="fSave(scope.submitHandler)">
                      回复
                    </el-button>
                </div>
                <div v-else>
                    <el-button icon="el-icon-circle-check" type="primary" @click="fSave(scope.submitHandler)">
                      追加回复
                    </el-button>
                </div>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import yyglUpload from './components/yygl-upload'

export default {
    mixins: [FORM_PAGE_MIXIN],
    components:{yyglUpload},
    data() {
        return{
            tableData:[],
            dialogVisible:false,
            form:{
                txthfcontent:''
            },        
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        // 提交
         fSave:function(cb){           
            cb()
         },
        submitHandler:function(){
            var that=this
            that.$post(`${this.getGetters('bidUrl')}/FaBiao/CqWt/add.json`,
            {   
                id:this.getQuery('id'),
                txthfcontent:this.form.txthfcontent
            }, (data, res) => {
                ShowMsg(res.msg,'success');
                this.cancleHandler();
            });
        },
    },
    created() {
       this.jspInit(`${this.getGetters('bidUrl')}/FaBiao/CqWt/edit.json`,{
           procode:this.getQuery('procode'),
           id:this.getQuery('id'),
        }, (data) => {
            this.form=data.model,
            this.isnm = !!data.isnm ? data.isnm : '0';
        });
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">

</style>
